var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 3.97674C0 1.78045 1.78045 0 3.97674 0C6.17304 0 7.95349 1.78045 7.95349 3.97674C7.95349 6.17304 6.17304 7.95349 3.97674 7.95349C1.78045 7.95349 0 6.17304 0 3.97674Z",
    fill: "#6929E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0234C0 11.827 1.78045 10.0466 3.97674 10.0466C6.17304 10.0466 7.95349 11.827 7.95349 14.0234C7.95349 16.2197 6.17304 18.0001 3.97674 18.0001C1.78045 18.0001 0 16.2197 0 14.0234Z",
    fill: "#6929E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0465 14.0234C10.0465 11.827 11.8269 10.0466 14.0233 10.0466C16.2196 10.0466 18 11.827 18 14.0234C18 16.2197 16.2196 18.0001 14.0233 18.0001C11.8269 18.0001 10.0465 16.2197 10.0465 14.0234Z",
    fill: "#6929E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.814 0.418701C14.2763 0.418701 14.6512 0.793537 14.6512 1.25591V3.34893H16.7442C17.2066 3.34893 17.5814 3.72377 17.5814 4.18614C17.5814 4.64852 17.2066 5.02335 16.7442 5.02335H14.6512V7.11638C14.6512 7.57877 14.2763 7.95358 13.814 7.95358C13.3516 7.95358 12.9767 7.57877 12.9767 7.11638V5.02335H10.8837C10.4213 5.02335 10.0465 4.64852 10.0465 4.18614C10.0465 3.72376 10.4213 3.34893 10.8837 3.34893H12.9767V1.25591C12.9767 0.793537 13.3516 0.418701 13.814 0.418701Z",
    fill: "#6929E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.4cc409a3c8b7c397c1372ed8e7581e8b.svg";
export { ForwardRef as ReactComponent };